const ReportTemplateReformatCopyData = (listRawData) => {
  const _list = [];

  for (let rawData of listRawData) {
    const row = {};

    row["type"] = Number(rawData.is_free) === 1 ? "FREE" : "PAID";
    row["category_name"] = rawData.category_name;
    row["product_name"] = rawData.product_name;
    row["total_quantity"] = rawData.total_quantity;
    row["product_price"] = rawData.product_price;
    row["sub_total"] = rawData.sub_total;
    row["discount"] = Number(rawData.is_free) === 1 ? 0 : rawData.sub_total - rawData.grand_total;
    row["grand_total"] = rawData.grand_total;

    _list.push(row);
  }

  return _list;
};

export default ReportTemplateReformatCopyData;
